<template>
  <div class="text-center" style="margin-top: 20vh">
    <img :src="logo" alt="" class="mb-3">
    <template v-if="$root.msg==='NO_PLAN'">
      <p>Vous avez besoin d'un abonnement pour accéder à vos contenus</p>
      <a :href="plans" class="btn btn-outline-green">Prendre un abonnement</a>
    </template>
    <!--    display that for any other errors-->
    <template v-else-if="$root.msg==='NO_ACCESS' || true">
      <p v-if="">Vous ne pouvez pas accèder à cette plateforme</p>
      <a :href="home" class="btn btn-outline-green">Acceuil</a>
    </template>
  </div>
</template>

<script>
export default {
  name: "Error",
  data() {
    return {
      msg: null
    }
  },
  computed: {
    logo() {
      return process.env.VUE_APP_PROXY + '/images/logo.jpg'
    },
    home() {
      return process.env.VUE_APP_HOME
    },
    plans() {
      return process.env.VUE_APP_HOME + '/plans'
    }
  },
}
</script>

<style scoped>

</style>
